/* eslint-disable no-unreachable */
// import Vue from 'vue';
// import TIM from 'tim-js-sdk';

// 视频直播聊天组件

import ContextMenu from '@/components/common/context-menu';
import { decodeText } from '@/utils/decodeText';
// import i18n from '@/locales/i18n';
import { mapState } from 'vuex';
import { emojiMap, emojiName, emojiUrl } from '@/utils/emojiMap';
import { LIVE_STAGE } from '@/constants/room';

import { chatRoomSendMsg, chatRoomGetMsgList, chatRoomGetMsgListSum, updateLiveStreamType } from '@/api/live';
import {
  SET_COMMENT_SUM,
} from '@/constants/mutation-types';

import { isAdminstator, imMsgStateMap } from '../../../diff.js'

const TIM = {};

export default {
  data() {
    return {
      isSdkReady: false,
      inputMsg: '',
      popoverVisible: false,
      isNotExistRoom: false,
      emojiMap,
      emojiName,
      emojiUrl,

      isAdminstator,

      messageList: [], // 消息列表
      muteUserIdList: [], // 被禁言的用户ID列表

      isSendMsgFlag: false,
      msgLoopTimer: null,  // 轮询定时器
      msgLoopTime: 10 * 1000,  // 间隔时间

      pagination: {
        page: 0,
        size: 50,
        defaultSize: 50,
        total: 0
      },

      fileList: [],
      imgUploadPreFixData: {},

      currentNode: null,
      isViewMsgIng: false, // 正在查看消息
    };
  },
  components: {
    ContextMenu
  },
  computed: {
    ...mapState({
      sdkAppId: state => state.player.sdkAppId,
      userSig: state => state.player.userSig,
      liveStage: state => state.player.liveStage,
      userInfo: state => state.player.userInfo,
      roomId: state => state.player.roomId,
      anchorUserId: state => state.player.anchorUserId,
      sendMsgEnable: state => state.player.sendMsgEnable,
      chatRoomEnable: state => state.player.chatRoomEnable,
      isActive: state => state.player.isActive,
    }),
    groupID() {
      return this.roomId.toString();
    },
    userData() {
      return {
        sdkAppId: this.sdkAppId,
        userSig: this.userSig,
        userId: this.userInfo.userId,
      };
    },
    isLiveEnded() {
      return this.liveStage === LIVE_STAGE.ENDED;
    },
    // 客户未登录时展示登录提示
    showLoginAttention() {
      return !this.userInfo || this.userInfo.userId === 'user_audience' || !this.userSig;
    },
    inputPlaceHolder() {
      if (this.showLoginAttention) {
        return '';
      }
      if (!this.sendMsgEnable) {
        return '禁言中';
      }

      if (this.$isMobile) {
        return '说点什么';
      }
      return '说点什么，按Enter键发送消息';
    },
  },
  watch: {
    sdkAppId: {
      immediate: true,
      handler() {
        if (!this.$tim) {
          // 先不初始化了,用不到tim

          // Vue.prototype.$tim = TIM.create({
          //   SDKAppID: this.sdkAppId,
          // });
        }
      },
    },
    userData: {
      immediate: true,
      async handler(val) {
        // 先不初始化了,用不到tim

        // const { userSig, userId } = val;
        // if (userId && userSig) {
        //   await this.loginTim({ userId, userSig });
        //   await this.joinGroup();
        // }

        if (this.roomId && this.chatRoomEnable) {
          this.initMsgList((hasMoreFlag) => {
            console.log('初始化加载完成,开始轮询')

            // 将轮询页码调整至最后一页, 页码从 0 开始
            const curpage = Math.ceil(this.pagination.total / this.pagination.size) - 1;

            this.pagination.page = curpage;

            console.log('当前页', curpage)

            this.getMsgList();
          });
        }
      },
    },
    // 发出一条新消息，自动到最底部
    messageList() {
      // 鼠标正在滑动，消息不往下滚
      if (this.isViewMsgIng) {
        return false;
      }

      this.$nextTick(() => {
        const msg =  this.$refs.box;
        msg.scrollTop = msg.scrollHeight;
      });
    },
  },
  methods: {
    // 获取用户昵称
    getUserNick({ nick, userID }) {
      return nick ? nick : userID;
    },
    // 是否是主播的消息
    isAnchorMessage({ userID }) {
      return userID === this.anchorUserId;
    },
    // 获取消息时间
    getMessageTime({ time }) {
      // let hour = new Date(time * 1000).getHours();
      // let minute = new Date(time * 1000).getMinutes();
      // hour = hour >= 10 ? hour.toString() : `0${hour}`;
      // minute = minute >= 10 ? minute.toString() : `0${minute}`;
      // return `${hour}:${minute}`;

      const timestamp = time;
      if (!timestamp) return ''
      const publishTime = new Date(timestamp) / 1000
      const date = new Date(publishTime * 1000)
      const Y = date.getFullYear()
      let M = date.getMonth() + 1
      let D = date.getDate()
      let H = date.getHours()
      let m = date.getMinutes()
      let s = date.getSeconds()
      // 小于10的在前面补0
      if (M < 10) {
        M = `0${M}`
      }
      if (D < 10) {
        D = `0${D}`
      }
      if (H < 10) {
        H = `0${H}`
      }
      if (m < 10) {
        m = `0${m}`
      }
      if (s < 10) {
        s = `0${s}`
      }
      // return `${Y}-${M}-${D} ${H}:${m}:${s}`
      return `${M}-${D} ${H}:${m}:${s}`
    },
    // 发送消息
    handleSendMsg() {
      if (this.isActive === 2) {
        this.$message.warning('直播已结束，无法发送消息');
        return false;
      }
      if (this.isActive === -99) {
        this.$message.warning('暂无直播，无法发送消息');
        return false;
      }
      if (!this.sendMsgEnable) {
        this.$message.warning('禁言中');
        return false;
      }

      if (!this.chatRoomEnable) {
        this.$message.warning('聊天室暂时关闭');
        return false;
      }

      if (this.showLoginAttention || this.inputMsg === '' || /^\s+$/gi.test(this.inputMsg)) {
        this.$message.warning('发送内容不能为空~');
        return false;
      }
      this.sendMessage(this.inputMsg);
      this.inputMsg = '';
      this.popoverVisible = false;
    },
    // 选择表情
    chooseEmoji(item) {
      if (this.showLoginAttention) {
        return;
      }
      this.inputMsg += item;
      !this.$isMobile && this.$refs.input.focus();
    },
    // 处理登录
    handleLogin(platform) {
      this.$eventBus.$emit('showLoginCard');

      if (platform === 'pc') {
        window.location.href =  'https://www.xkb.com.cn/fundhtml/#/guidePage';
      } else {
        window.openToApp();
      }
    },

    // --------- TIM 登录登出 ---------
    // 登录即时通信 IM
    async loginTim({ userId, userSig }) {
      try {
        await this.$tim.login({
          userID: userId,
          userSig,
        });
      } catch (imError) {
        // const errorInfo = i18n.t('tim.Failed to initialize streaming group') + i18n.t('tim.Refresh and try again');
        const errorInfo = 'tim.Failed to initialize streaming group' + 'tim.Refresh and try again';
        this.$message.error(errorInfo);
        console.error('im | login | failed', imError); // 登录失败的相关信息
      }
    },
    // 登出即时通信 IM
    async logout() {
      try {
        await this.$tim.logout();
      } catch (imError) {
        console.error('logout error:', imError);
      }
    },

    // ----------- 群组相关 ------------
    // 加入创建的直播群
    async joinGroup() {
      try {
        await this.$tim.joinGroup({
          groupID: this.groupID,
          type: TIM.TYPES.GRP_AVCHATROOM,
        });
      } catch (error) {
        switch (error.code) {
          case 10015:
            this.$message.error('直播间不存在');
            break;
          default:
            this.$message.error('加入直播聊天群失败，请刷新重试');
            break;
        }
        console.error('joinGroup error:', error); // 申请加群失败的相关信息
      }
    },
    // 退群
    async quitGroup() {
      try {
        await this.$tim.quitGroup(this.groupID);
      } catch (error) {
        console.error('quitGroup error:', error); // 申请退群失败的相关信息
      }
    },
    // 判断群组是否存在
    async searchGroup(groupId) {
      try {
        await this.$tim.searchGroupByID(groupId);
      } catch (error) {
        switch (error.code) {
          case 10015:
            this.$message.error('直播间不存在');
            break;
          default:
            break;
        }
        throw error;
      }
    },
    // 获取群信息
    async getGroupProfile(groupId) {
      return await this.$tim.getGroupProfile({ groupID: groupId });
    },

    // ----------- 收发消息相关 ----------
    // 监听事件
    handleTimEvents() {
      // 登录成功后会触发 SDK_READY 事件，该事件触发后，可正常使用 SDK 接口
      this.$tim.on(TIM.EVENT.SDK_READY, this.onReadyStateUpdate);
      // SDK NOT READY
      this.$tim.on(TIM.EVENT.SDK_NOT_READY, this.onNotReadyStateUpdate);
      // 被踢出
      this.$tim.on(TIM.EVENT.KICKED_OUT, this.onKickOut);
      // SDK内部出错
      this.$tim.on(TIM.EVENT.ERROR, this.onError);
      // 收到新消息
      this.$tim.on(TIM.EVENT.MESSAGE_RECEIVED, this.onTextMessageReceived);
    },
    // SDK READY
    async onReadyStateUpdate() {
      // 修改个人标配资料
      try {
        await this.$tim.updateMyProfile({
          nick: this.userInfo.userName,
          avatar: this.userInfo.userAvatar || '',
        });
      } catch (imError) {
        console.error('updateMyProfile error:', imError); // 更新资料失败的相关信息···
      }
    },
    // SDK NOT READY
    onNotReadyStateUpdate() {
      this.$message.error('TIM SDK NOT READY, please refresh!');
    },
    // 接收文本消息
    onTextMessageReceived(event) {
      const messageList = event.data;
      messageList.forEach((message) => {
        if (message.type === TIM.TYPES.MSG_TEXT) {
          this.messageList.push({
            nick: message.nick || message.from,
            content: message.payload.text,
            renderContent: decodeText(message.payload.text),
            userID: message.from,
            avatar: message.avatar,
            time: message.time,
          });
        }
      });
    },
    // 发送消息
    async sendMessage(msgText) {
      if (this.isSendMsgFlag) {
        this.$message.error('正在发送消息，请稍等~');
        return false;
      }

      this.isSendMsgFlag = true;
      // 创建消息并发送到对应群组
      const messageItem = {
        nick: this.userInfo.userName || '',
        content: msgText,
        renderContent: decodeText(msgText),
        userID: this.userInfo.userId,
        // eslint-disable-next-line newline-per-chained-call
        time: Number(Date.now()),
        // time: Number(Date.now().toString().substr(0, 10)),
      };

      console.log(messageItem, '???');
      try {
        const msgRes = await chatRoomSendMsg({
          targetId: this.roomId,
          content: msgText,
          targetType: 'liveStream',
          isAdmin: isAdminstator ? 1 : 0,
          liveStreamCommentType: 1,
        });

        messageItem.id = msgRes.id;

        if (msgRes.hasSensword) {
          messageItem.state = 'fail';
          messageItem.hasSensword = true;
          messageItem.time = Number(new Date(msgRes.modDate).getTime());
          this.$message.warning('不可以发送敏感信息~');
        } else {
          messageItem.state = 'success';
        }
      } catch (error) {
        messageItem.state = 'fail';
      }
      this.isSendMsgFlag = false;
      this.messageList.push(messageItem);
    },

    // 重发信息
    reSendMessage(item) {
      if (item.hasSensword) {
        this.$message.warning('不可以发送敏感信息~');
        return false;
      }
      this.sendMessage(item.content)
    },

    async getMsgList() {
      if (this.msgLoopTimer) window.clearInterval(this.msgLoopTimer);

      this.msgLoopTimer = window.setInterval(async () => {
        const listSum  = await chatRoomGetMsgListSum({ roomId: this.roomId });

        this.$store.commit(`player/${SET_COMMENT_SUM}`, listSum);

        this.pagination.total = listSum;

        if (this.pagination.total ===  this.messageList.length) {
          console.log('总数没变')
          return false;
        }

        const params = Object.assign({ roomId: this.roomId }, this.pagination);

        chatRoomGetMsgList(params).then((res) => {
          if (res.length > 0) {
            this.handleMsgList(res, (hasMoreFlag) => {
              if (hasMoreFlag) {
                this.pagination.page = this.pagination.page + 1;

                console.log('加分页', this.pagination.page)
              }
            })
          }
        });
      }, this.msgLoopTime)
    },

    // 初始化加载聊天记录 列表
    async initMsgList(callback) {
      // if (this.msgLoopTimer) window.clearInterval(this.msgLoopTimer);
      // this.msgLoopTimer = window.setInterval(async () => {

      const listSum  = await chatRoomGetMsgListSum({ roomId: this.roomId });

      this.$store.commit(`player/${SET_COMMENT_SUM}`, listSum);

      this.pagination.total = listSum;

      // 判断总数一共有多少
      // this.pagination.size = Math.floor(listSum / 2);

      const params = Object.assign({ roomId: this.roomId }, this.pagination);
      if (listSum) {
        params.size = listSum;
      }

      chatRoomGetMsgList(params).then((res) => {
        if (res.length > 0) {
          this.handleMsgList(res, (hasMoreFlag) => {
            callback(hasMoreFlag)
          })
        }
      });
      // }, 5 * 1000)
    },

    // 处理直播列表
    handleMsgList(res, callback) {
      console.log('直播列表', res, this.messageList);
      // 处理新数据

      const newList = res.filter(item => !this.messageList.some(x => x.id === item.id));

      console.log('diff', newList);

      const arr = [];

      newList.map((item, index) => {
        // console.log(decodeText(item.content))

        let nick = item.nickname || '';

        // 说明是管理员
        if (item.isAdmin) {
          if (isAdminstator) {
            nick = `(管理员) ${nick}`;
          } else {
            nick = '管理员'
          }
        }

        arr.push({
          id: item.id,
          content: item.content,
          renderContent: decodeText(item.content),
          userID: item.publisherFullname,
          hasSensword: item.hasSensword ? item.hasSensword : false,
          nick, // 显示中文名
          // state: 'success',
          state: imMsgStateMap[item.liveStreamCommentType],
          // eslint-disable-next-line newline-per-chained-call
          time: Number(new Date(item.modDate).getTime()),
          // time: Number(new Date(item.modDate).getTime().toString().substr(0, 10)),
        })
      });

      this.messageList = this.messageList.concat(arr);

      // console.log(this.messageList)

      // hasMore
      if (this.messageList.length < this.pagination.total) {
        if (typeof callback === 'function') {
          callback(true)
        }
      } else {
        if (typeof callback === 'function') {
          callback(false)
        }
      }
    },

    sendImage() {
      // 发送完清除
    },

    // 上传图片成功
    handleImgUploadSuccess(res, file) {
      const imageUrl = URL.createObjectURL(file.raw);
      console.log(imageUrl, res)
    },
    handleImgBeforeUpload(uploadFile) {
      console.log(uploadFile)

      this.imgUploadPreFixData = {
        tenantId: this.userInfo.tenantId === 'STCN' ? 1 : this.userInfo.tenantId,
        // tenantId: 1,
        // binaryId: uploadFile.uid,
        binaryId: uploadFile.name,
        mimeType: uploadFile.type
      }
      const promise = new Promise((resolve) => {
        this.$nextTick(() => {
          resolve(true);
        });
      });
      return promise;
    },


    // 错误
    onError() {

    },
    // 被踢出
    onKickOut() {

    },

    // 右键点击开始
    contextmenu(node) {
      if (!isAdminstator) {
        return false
      }
      event.preventDefault();
      this.currentNode = node;
      this.$refs.allMenu.open(event);
    },

    updateMsgType(currentNode, type) {
      updateLiveStreamType({
        id: currentNode.id,
        type,
      }).then(() => {
        this.$message.success('操作成功~');
        currentNode.state = imMsgStateMap[type]
      })
    },

    restoreMessage(currentNode) {
      this.updateMsgType(currentNode, 1)
    },

    // 隐藏信息
    hideMsg(currentNode) {
      this.updateMsgType(currentNode, 0)
    },

    deleteMsg(currentNode) {
      this.$alert(
        '删除该条消息？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          this.updateMsgType(currentNode, 2)
        })
        .catch(() => {

        })
    },


    // 2、进入元素
    mouseenter() {
      // console.log('mouseenter')
      this.isViewMsgIng = true;
    },
    // 3、移动
    mousemove() {
      // console.log('mousemove')
      this.isViewMsgIng = true;
    },
    // 5、离开元素
    mouseleave() {
      // console.log('mouseleave')
      this.isViewMsgIng = false;
    }
  },
  created() {
    // this.handleTimEvents();
  },

  beforeDestroy() {
    if (this.msgLoopTimer) window.clearInterval(this.msgLoopTimer);
  },
};
